import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'

import { deleteWorkflow } from './services/mutateWorkflow'
import { invalidateLoadWorkflows } from './useLoadWorkflows'

type DeleteProps = {
  id: number
}

export const useDeleteWorkflows = (
  options?: Omit<
    UseMutationOptions<void, Error, DeleteProps, unknown>,
    'mutationKey' | 'mutationFn' | 'onSuccess'
  >
) => {
  const mutation = useMutation({
    mutationKey: [QUERIES.AUTOMATIONS.WORKFLOWS.DELETE],
    mutationFn: async ({ id }: DeleteProps) => await deleteWorkflow(id),
    onSuccess: async () => await invalidateLoadWorkflows(),
    ...options,
  })

  const deleteWorkflowReq = async ({ id }: DeleteProps) => {
    return mutation.mutateAsync({ id })
  }

  return {
    deleteWorkflow: deleteWorkflowReq,
    ...mutation,
  }
}
